import { mapP } from 'root/src/shared/util/ramdaPlus'

export default (condition, fn, result = undefined) => (Array.isArray(fn)
	? mapP(f => (condition ? f() : result), fn)
	: (condition ? fn() : result))
